import { render, staticRenderFns } from "./ConfigurationSettings.vue?vue&type=template&id=3ca3ccf8"
import script from "./ConfigurationSettings.vue?vue&type=script&lang=js"
export * from "./ConfigurationSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports